import { dateProvider } from '@/helpers/date'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import { nextMonday, addDays } from 'date-fns'
import femaleLoaderJson from '@/data/lottie-animations/femaleLoader.json'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingLottieAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => {
			const nextMondayDate = nextMonday(addDays(new Date(), -1))
			const formattedDate = dateProvider.format(nextMondayDate, 'MMMM do')

			return {
				title: `Monday ${formattedDate}: 28-Day Wall Pilates Challenge based on your age`,
				size: 'small',
				customStyles: {
					marginLeft: '0.5rem',
					marginRight: '0.5rem',
				},
			}
		},

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: femaleLoaderJson,
			loop: false,
			customStyles: {
				height: '50vh',
				marginTop: 'var(--size-18)',
				marginBottom: 'var(--size-18)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
